import { render, staticRenderFns } from "./SeverityMultiSelect.vue?vue&type=template&id=34d38732"
import script from "./SeverityMultiSelect.vue?vue&type=script&lang=js"
export * from "./SeverityMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports